import React from 'react';

import { format } from 'date-fns';

export interface MessageProps {
  date: Date;
  fullWidth?: boolean;
  id: string | number;
  imageUrl?: string;
  name: string;
  owner: 'bot' | 'user';
  text?: React.ReactNode;
}

const Message: React.FC<MessageProps> = ({
  date,
  fullWidth,
  id,
  imageUrl,
  name,
  owner,
  text
}) => (
  <div className={`msg ${owner === 'bot' ? 'left-msg' : 'right-msg'}`} key={id}>
    <div
      className="msg-img"
      style={{
        backgroundImage: `url(${owner === 'bot'
          ? require('../../assets/images/jb-profile.png')
          : ''
        })`
      }}
    />
    <div className="msg-bubble" style={{ width: fullWidth ? '100%' : undefined }}>
      <div className="msg-info">
        <div className="msg-info-name">
          {name}
        </div>
        <div className="msg-info-time">
          {format(date, 'HH:mm')}
        </div>
      </div>
      {
        imageUrl && (
          <img alt="..." src={imageUrl} style={{ height: 'auto', width: '100%' }} />
        )
      }
      {
        text && (
          <div className="msg-text">
            {
              text.toString().indexOf('</') !== -1
                // eslint-disable-next-line react/no-danger
                ? <div dangerouslySetInnerHTML={{ __html: text.toString().replace(/(<? *script)/gi, 'illegalscript') }} />
                : text
            }
          </div>
        )
      }
    </div>
  </div>
);

Message.defaultProps = {
  fullWidth: false
}

export default Message;
